import { HelpIsland } from '../../pure/help-island';
import { ToolContainer } from '../../workspace';

export const HubIsland = () => {
  return (
    <ToolContainer>
      <HelpIsland />
    </ToolContainer>
  );
};
